import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Avatar, Card } from 'antd';

import styles from './index.module.scss';

const menus = [
  {
    label: 'ข้อมูลของฉัน',
    path: '/profile/my-profile',
    icon: '/images/my-profile/my-profile.svg',
  },
  {
    label: 'ที่อยู่ของฉัน',
    path: '/profile/my-address',
    icon: '/images/my-profile/my-location.svg',
  },
  {
    label: 'คำสั่งซื้อสินค้าของฉัน',
    path: '/profile/my-order',
    icon: '/images/serviceJob/icon-technician-order.svg',
  },
  {
    label: 'ประวัติการติดต่อช่างของฉัน',
    path: '/profile/service-orders',
    icon: '/images/serviceJob/icon-technician-profile.svg',
  },
  {
    label: 'บัญชีธนาคาร',
    path: '/profile/my-bank-account',
    icon: '/images/my-profile/my-bank-account.svg',
  },
  {
    label: 'สะสมคะแนนกับ SCG Family',
    path: '/profile/scg-family',
    icon: '/images/my-profile/my-scg-family.svg',
  },
];

const ProfileMenu: React.FC = () => {
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user);
  const [currentUser, setCurrentUser] = useState<any>({});
  const location = useLocation();
  const [profile, setProfile] = useState<any>('');
  const [profileImage, setProfileImage] = useState<any>('');
  const [profileName, setProfileName] = useState<any>('');
  const currentPath = useSelector(() => location?.pathname);

  useEffect(() => {
    setProfileImage(currentUser.photoURL);
    setProfile(currentUser.photoURL);
    setProfileName(currentUser.displayName);
  }, [currentUser]);

  useEffect(() => {
    setCurrentUser(user);
  }, [user]);

  return (
    <>
      <div className={styles.profileMenu}>
        {menus.map((menu) => (
          <div
            key={menu.label}
            className={[
              styles.menuItem,
              currentPath === menu.path ? styles.active : '',
            ].join(' ')}
            onClick={() => navigate(`${menu.path}`)}
          >
            <img className={styles.menuIcon} src={menu.icon} />
            <div className={styles.menuLabel}>{menu.label}</div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ProfileMenu;
